
// ABOUTME: User profile page with URL routing support
// ABOUTME: Displays and manages user profile information

import React from 'react';
import PublicProfile from '@/components/PublicProfile';

const MyProfile = () => {
  return <PublicProfile />;
};

export default MyProfile;
